package com.essntl.features.category.ui.addeditcategory

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.category.domain.model.CategoryModel

data class AddEditCategoryState(
    val category: MutableState<CategoryModel> = mutableStateOf(CategoryModel.empty),
    val getCategory: State<CategoryModel> = State(),
    val getCategoryIconsUrl: State<List<String>> = State(),
    val addEditCategory: State<CategoryModel> = State(),
    val deleteCategory: State<Unit> = State(),
    val isEditEnabled: Boolean = false,

    // Category Count
    val getServicesCategoryCount: State<Long> = State(),
    val getSuppliersCategoryCount: State<Long> = State(),
) {
    val countLoading
        get() = getServicesCategoryCount.isLoading ||
            getSuppliersCategoryCount.isLoading

    val countFailure
        get() = getServicesCategoryCount.isFailure ||
            getSuppliersCategoryCount.isFailure

    val count
        get() = (getServicesCategoryCount.data ?: 0) +
            (getSuppliersCategoryCount.data ?: 0)
}
